import styled, { css } from 'styled-components';
import { AlertProps, AlertWrapper } from '@anm/components/notification/Alert';
import { ExpandMenuItem, IconArrow } from '@anm/components/Collapse';

type WarningMessageProps = AlertProps & {
  isCollapse?: boolean;
};

export const Wrapper = styled.div`
  padding-bottom: 16px;

  ${ExpandMenuItem} {
    position: relative;
    flex-direction: row;
    max-width: 560px;
  }

  ${IconArrow} {
    position: absolute;
    top: 35px;
    right: 10px;
  }
`;

export const WarningMessage = styled(AlertWrapper)<WarningMessageProps>`
  padding: 16px;
  max-width: 560px;
  font-size: 14px;
  line-height: 20px;
  flex-grow: 1;
  color: #292a2b;
  flex-direction: row;
  border-radius: 10px;

  ${({ isCollapse }) =>
    isCollapse &&
    css`
      margin-bottom: 8px;
    `}

  &:not(:first-of-type) {
    margin-top: 8px;
  }

  p {
    margin: 0;
  }

  span {
    color: #1593b7;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      text-decoration: none;
    }
  }

  ${({ variant }) =>
    variant === 'danger' &&
    css`
      border-color: var(--error);
    `}
`;
